<div class="psm__progress-bar" role="progressbar" [passwordStrength]="passwordStrength!"
  [numberOfProgressBarItems]="numberOfProgressBarItems" [colors]="colors">
  <div class="psm__progress-bar-items"></div>
  <div class="psm__progress-bar-overlay"></div>
</div>
@if(enableFeedback && feedback){
<ng-container>
  @if(feedback.warning){
  <small class="psm__feedback">
    {{ feedback.warning }}
  </small>
  }
  @if(feedback.suggestions && feedback.suggestions.length){
  <small class="psm__suggestion" style="color: red !important;">
    <!-- {{ 'The password has at least ' }} -->
    <ng-container *ngFor="let suggestion of feedback.suggestions; index as index; last as isLast">
      {{ suggestion }}{{ index === feedback.suggestions.length - 2 ? ' and ' : isLast ? '.' : ', ' }}
    </ng-container>
  </small>
  }
</ng-container>
}